import { getDefaultNode as getFoundationsDefaultNode, setDefaultNode as setFoundationsDefaultNode } from 'foundations-components/transitional/utils/RootNode';
export const setDefaultNode = node => {
  setFoundationsDefaultNode(node);
};
export const getDefaultNode = () => {
  return getFoundationsDefaultNode();
};